import { Component, forwardRef, Injector, Input, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ControlValueAccessor, FormGroupDirective, NG_VALUE_ACCESSOR, NgControl, NgForm, UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

const CUSTOM_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => TextInputComponent),
  multi: true,
};

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    selector: 'odq-text-input, [odq-text-input]',
    providers: [
        CUSTOM_VALUE_ACCESSOR,
    ],
    templateUrl: './text-input.component.html',
    styleUrls: ['./text-input.component.scss'],
    standalone: false
})
export class TextInputComponent implements OnInit, ControlValueAccessor {
  @Input() placeholder;
  @Input() badge;
  @ViewChild('inputField', { static: true }) inputField;

  matcher = new MyErrorStateMatcher();
  public disabled: boolean;

  private inputValue: string;
  private onChange: Function;
  private onTouched: Function;

  ngControl: NgControl;

  constructor(private inj: Injector, private renderer: Renderer2) {
    this.onChange = (_: any) => { };
    this.onTouched = () => { };
    this.disabled = false;
  }

  ngOnInit(): void {
    this.ngControl = this.inj.get(NgControl);
  }

  updateValue($event) {
    const value = $event.currentTarget.value;
    this.inputValue = value;
    this.onChange(this.inputValue);
    this.onTouched();
  }

  writeValue(obj: any): void {
    this.inputValue = obj;
    const inputTag = this.inputField.nativeElement;
    this.renderer.setProperty(inputTag, 'value', this.inputValue);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
